import toggleVisibility from '../utils/toggleVisibility';

const GROUP_SELECTOR = '[data-choice-group]';
const CHOICE_SELECTOR = '[data-choice-value]';
const INPUT_SELECTOR = '[data-choice-input]';
const SELECTED_SELECTOR = '[data-choice-selected]';
const ERROR_SELECTOR = '[data-choice-error]';

const isGroupVisible = (groupEl) => !groupEl.classList.contains('hidden');

const toggleError = (groupEl, isVisible) => {
  const errorEl = groupEl.querySelector(ERROR_SELECTOR);
  if (errorEl) toggleVisibility(errorEl, isVisible, 'block');
};

// The property input stays disabled until a choice is made, so atcForm.js
// (which skips disabled inputs) never submits an empty or hidden group's value.
const setGroupValue = (groupEl, value) => {
  const inputEl = groupEl.querySelector(INPUT_SELECTOR);
  const selectedEl = groupEl.querySelector(SELECTED_SELECTOR);
  if (inputEl) {
    inputEl.value = value;
    inputEl.disabled = !value;
  }
  if (selectedEl) selectedEl.textContent = value;
};

const resetGroup = (groupEl) => {
  groupEl.querySelectorAll(CHOICE_SELECTOR).forEach(choiceEl => choiceEl.setAttribute('aria-pressed', 'false'));
  setGroupValue(groupEl, '');
  toggleError(groupEl, false);
};

const selectChoice = (choiceEl) => {
  const groupEl = choiceEl.closest(GROUP_SELECTOR);
  if (!groupEl) return;
  groupEl.querySelectorAll(CHOICE_SELECTOR).forEach(otherEl => {
    otherEl.setAttribute('aria-pressed', String(otherEl === choiceEl));
  });
  setGroupValue(groupEl, choiceEl.dataset.choiceValue);
  toggleError(groupEl, false);
};

// Colour choice groups belong to one variant each - only the selected variant's
// is shown, and any group being hidden is cleared so its choice can't carry over.
const showGroupsForVariant = (formEl, variantId) => {
  if (!variantId) return;
  formEl.querySelectorAll('[data-choice-variant-id]').forEach(groupEl => {
    const isMatch = groupEl.dataset.choiceVariantId === String(variantId);
    if (!isMatch) resetGroup(groupEl);
    toggleVisibility(groupEl, isMatch);
  });
};

// Called from atcForm.js before adding to cart: every visible group needs a
// choice. Shows each missing group's prompt and moves focus to the first one.
export const validateRequiredChoices = (formEl) => {
  const missingGroupEls = [...formEl.querySelectorAll(GROUP_SELECTOR)]
    .filter(groupEl => isGroupVisible(groupEl) && groupEl.querySelector(INPUT_SELECTOR)?.disabled);

  missingGroupEls.forEach(groupEl => toggleError(groupEl, true));
  missingGroupEls[0]?.querySelector(CHOICE_SELECTOR)?.focus();
  return missingGroupEls.length === 0;
};

const initProductChoices = (containerEl = document) => {
  containerEl.querySelectorAll('[data-product-form]').forEach(formEl => {
    if (!formEl.querySelector(GROUP_SELECTOR) || formEl.dataset.choicesBound === 'true') return;
    formEl.dataset.choicesBound = 'true';

    formEl.addEventListener('click', (evt) => {
      const choiceEl = evt.target.closest(CHOICE_SELECTOR);
      if (choiceEl) selectChoice(choiceEl);
    });

    // Dispatched by product-variants.js whenever the selected variant changes.
    formEl.addEventListener('variant:change', (evt) => showGroupsForVariant(formEl, evt.detail?.variant?.id));

    // product-variants.js may already have resolved the variant (e.g. from the
    // URL) before this ran, so sync to whatever the form currently holds.
    showGroupsForVariant(formEl, formEl.querySelector('[data-atc-id-input]')?.value);
  });
};

export default initProductChoices;
